// extracted by mini-css-extract-plugin
export default {"icon":"PartnersPage_icon__IsvIs","sectionLabel":"PartnersPage_sectionLabel__9v3Mc"};